import { PmuService } from './../data/pmu.service';
import { Injectable } from '@angular/core';
import * as qz from 'qz-tray';
import { ConfigService } from '../config/config.service';
import { EscPosCommand } from '../../functions/ticket-data-formatter';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, catchError, lastValueFrom, map, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PrintService {
  private endpoint = '/print-esc-pos';
  printingTicket$ = new BehaviorSubject<boolean>(false);

  constructor(private readonly config: ConfigService, private httpClient : HttpClient, private pmuService: PmuService) {}

  get httpEndpoint(){
    return this.config.printerInfo.printer.domain + ":" + this.config.printerInfo.printer.port + this.endpoint;
  }

  printTicket(lines: string[]) {
    localStorage.setItem('currentTicket', JSON.stringify({ lines }));
    this.printingTicket$.next(true);
    if(this.config.printerInfo.type === 'http'){
      return lastValueFrom(this.httpClient.post(this.httpEndpoint, { lines }, {
        headers: {
          'Content-Type': 'application/json',
        },
      }).pipe(
          map((res: any) => {
            let response = res.hasOwnProperty('erc') && (Number(res['erc']) === 1);
            let msg = res.hasOwnProperty('erc') ? (Number(res['erc']) === 404 ? 'print_status.printer_not_connected' : 'print_status.printing_failed') : 'print_status.printing_failed';
            if(response){
              localStorage.removeItem('currentTicket');
              msg = 'print_status.success';
            }
            this.pmuService.overLayLoader$.next(false);
            this.printingTicket$.next(false);
            return { status: response, msg };
          }),
          catchError((err) => {
              console.error('Ticket print failed:', err);
              this.pmuService.overLayLoader$.next(false);
              this.printingTicket$.next(false);
              return of({ status: false, msg: 'print_status.printing_failed' });
          })
        ));
    }else {
      return qz.websocket.connect().then(() => {
        const config = qz.configs.create(this.config.printerInfo.name);
        return EscPosCommand(lines, this.config.printerInfo.cpl).then((result) => {
              let data: any = [{
                  type: 'raw',
                  format: 'base64',
                  data: btoa(String.fromCharCode(...result))
              }];

              return qz.print(config, data);
            });
      }).then(() => {
        return qz.websocket.disconnect().then(() => {
          localStorage.removeItem('currentTicket');
          this.pmuService.overLayLoader$.next(false);
          this.printingTicket$.next(false);
          return { status: true, msg: 'print_status.success'};
        });
      }).catch((err) => {
        console.error('Ticket print failed:', err);
        this.pmuService.overLayLoader$.next(false);
        this.printingTicket$.next(false);
        return { status: true, msg: 'print_status.printing_failed'};
      });
    }
  }
}
